import * as Yup from "yup";

export const subDomainValidationSchema = Yup.object({
  subDomain: Yup.string(),
  ttl: Yup.number().typeError("Le TTL doit être un nombre !"),
  target: Yup.string().required("La cible est requise !"),
});
